/**
 * 先生(branch)画面のルーティング設定
 *   nameは原則としてパスと合わせること。
 *   lazyloadを無効化するためcomponent: CompornentNameの形で設定する
 */
import { RouteConfig } from 'vue-router'

// 対象画面import
import RootView from '../views/teacher/RootView.vue'
import TeacherLogin from '../views/teacher/TeacherLogin.vue'
import BranchStudents from '../views/teacher/BranchStudents.vue'
import BranchStudentsGeneralLearningProgress from '../views/teacher/BranchStudentsGeneralLearningProgress.vue'
import BranchStudentsSystemChartProgress from '../views/teacher/BranchStudentsSystemChartProgress.vue'
import StudentStudyCategoryProgress from '../views/teacher/StudentStudyCategoryProgress.vue'
import StudentLearningMapProgress from '../views/teacher/StudentLearningMapProgress.vue'
import CourseLearningProgress from '../views/teacher/CourseLearningProgress.vue'
import ClassLearningProgress from '../views/teacher/ClassLearningProgress.vue'

/**
 * 先生用ページ群
 */
const teacherRoutes: Array<RouteConfig> = [
  // ルートアクセス時のリダイレクト処理
  {
    path: '/teacher',
    name: 'TeacherRoot',
    component: RootView,
  },
  // ログイン
  {
    path: '/teacher/login',
    name: 'TeacherLogin',
    component: TeacherLogin,
  },
  // 生徒一覧
  {
    path: '/teacher/students',
    name: 'TeacherStudents',
    component: BranchStudents,
  },
  // 生徒毎通常学習進捗
  {
    path: '/teacher/students/progress/general',
    name: 'TeacherStudentsProgressGeneral',
    component: BranchStudentsGeneralLearningProgress,
  },
  // 生徒毎知識MAP系統図進捗
  {
    path: '/teacher/students/progress/map',
    name: 'TeacherStudentsProgressMap',
    component: BranchStudentsSystemChartProgress,
  },
  // 生徒別学習進捗
  {
    path: '/teacher/students/:userId/progress',
    name: 'TeacherStudentProgress',
    component: StudentStudyCategoryProgress,
  },
  // 生徒別学習進捗(知識マップ)
  {
    path: '/teacher/students/:userId/map',
    name: 'TeacherStudentMap',
    component: StudentLearningMapProgress,
  },
  // コース別学習進捗比較
  {
    path: '/teacher/course/progress',
    name: 'TeacherCourseProgress',
    component: CourseLearningProgress,
  },
  // クラス別学習進捗比較
  {
    path: '/teacher/class/progress',
    name: 'TeacherClassProgress',
    component: ClassLearningProgress,
  },
]

export default teacherRoutes
